/* v8 ignore file -- @preserve */
export default defineNuxtPlugin(() => {
  if (!window.__NAVIGATION_NEEDS_CSG__) {
    return;
  }

  const isMcom = import.meta.env.VITE_ENTRY_POINT === 'mcom';

  if (isMcom) {
    import('~/assets/scss/csg.mcom.scss');
  } else {
    import('~/assets/scss/csg.bcom.scss');
  }
});
